import { render, staticRenderFns } from "./TierPricing.vue?vue&type=template&id=3b750507&scoped=true&"
import script from "./TierPricing.vue?vue&type=script&lang=js&"
export * from "./TierPricing.vue?vue&type=script&lang=js&"
import style0 from "./TierPricing.vue?vue&type=style&index=0&id=3b750507&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b750507",
  null
  
)

export default component.exports